'use client';

export default function GlobalError({
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    return (
        <html>
            <body
                style={{
                    margin: 0,
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    padding: '2rem',
                    background: '#FAFAF9',
                    color: '#0C0A09',
                    fontFamily: 'sans-serif',
                }}
            >
                <p style={{ fontSize: '4rem', fontWeight: 800, lineHeight: 1, marginBottom: '0.5rem', color: '#CA8A04' }}>
                    Oops
                </p>
                <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.75rem' }}>
                    Something went wrong
                </h1>
                <p style={{ fontSize: '1rem', color: '#78716C', marginBottom: '2rem', maxWidth: 380 }}>
                    An unexpected error occurred. Please try again or return to the homepage.
                </p>
                <div style={{ display: 'flex', gap: 12 }}>
                    <button
                        onClick={reset}
                        style={{
                            padding: '12px 24px',
                            background: '#CA8A04',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 8,
                            fontWeight: 600,
                            fontSize: '0.9375rem',
                            cursor: 'pointer',
                        }}
                    >
                        Try Again
                    </button>
                    <a
                        href="/"
                        style={{
                            padding: '12px 24px',
                            background: 'transparent',
                            color: '#0C0A09',
                            border: '1px solid #D6D3D1',
                            borderRadius: 8,
                            fontWeight: 600,
                            fontSize: '0.9375rem',
                            textDecoration: 'none',
                        }}
                    >
                        Return Home
                    </a>
                </div>
            </body>
        </html>
    );
}
